import type { FC } from 'react';

import { useContent } from '@eneco/cms';
import { StickyNav as SparkyStickyNav } from '@eneco/sparky';

import type { StickyNavContent } from './sticky-nav-content.types';

/**
 * `StickyNav` block for the CMS-agnostic lane, serving **both** providers.
 *
 * Mirrors `libs/sitecore/components/content/src/StickyNav/StickyNav.tsx`: every item becomes one link of
 * Sparky's `StickyNav`. The legacy `getCombinedLinkFieldValueHref` is gone because both adapters already
 * put the query string and anchor into `href`. As in the legacy component, no item is filtered out: a
 * link whose URL could not be built keeps its empty `href`, so both lanes show the same entries.
 */
const StickyNav: FC = () => {
  const content = useContent<StickyNavContent>();

  const links = (content.items ?? []).map(item => ({
    active: item.active,
    href: item.link?.href ?? '',
    text: item.link?.text ?? '',
    target: item.link?.target,
  }));

  return <SparkyStickyNav links={links} />;
};

export default StickyNav;
